import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_UPDATE_RESPONSIBLE_MUTATION = graphql(/* GraphQL */ `
  mutation TesseractNegotiationDemandUpdateResponsible($id: UUID!, $data: TsrctDemandResponsibleUsersInput!) {
    tesseract {
      demand(id: $id) {
        responsibleUsers {
          update(data: $data) {
            id
            responsibleUserIds
          }
        }
      }
    }
  }
`);
